import { DesktopArrowDownRegular } from "@fluentui/react-icons";

import { FloatingNotificationButton } from "../floating-notification-button.js";

interface DesktopAppFloatingButtonProps {
  onClick: () => void;
  stackIndex: number;
}

export const DesktopAppFloatingButton = ({
  onClick,
  stackIndex,
}: DesktopAppFloatingButtonProps) => (
  <FloatingNotificationButton
    ariaLabel="Open desktop app information"
    icon={<DesktopArrowDownRegular className="h-6 w-6 text-white" />}
    label="Desktop app"
    onClick={onClick}
    stackIndex={stackIndex}
  />
);
